import EmailPage from "./emails.js";

export default class Pages {
    _EmailsPage
    get EmailsPage(){ return this._EmailsPage ?? (this._EmailsPage = (new EmailPage())) }
}
